import { Directive, Renderer2, ElementRef, AfterViewInit, Optional, Injector } from '@angular/core';
import { DateTime } from '@otas/utils/custom-components/datetime-component/datetime';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';

@Directive({
  selector: '[appDateClearButton]',
  standalone: false
})
export class DateClearButtonDirective implements AfterViewInit {
  private datepicker: BsDatepickerDirective | undefined;

  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    private injector: Injector
  ) {}

  ngAfterViewInit() {
    const datetimeComponent = this.injector.get(DateTime, null);
    if (datetimeComponent && datetimeComponent.datepickerRef()) {
      this.datepicker = datetimeComponent.datepickerRef();

      this.datepicker.bsConfig = {
        ...this.datepicker.bsConfig,
        showClearButton: true
      };
    } else {
      console.warn('Could not access BsDatepickerDirective from NKDatetime');
    }
  }

  // Optional: Keep ngDoCheck if you still need it
  ngDoCheck() {
    if (this.el.nativeElement.querySelector('input') === document.activeElement) {
      const clearElements = this.el.nativeElement.querySelectorAll('.clear');
      clearElements.forEach(element => {
        this.renderer.removeAttribute(element, 'style');
      });
    }
  }
}